export function isQaEmail(email: string) {
  return email.includes("komarevych.7");
}

export function addQaParamToUrl(url: string) {
  const urlObject = new URL(url);
  urlObject.searchParams.append("qa", "sanya");

  return urlObject.href;
}
